var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-card',[_c('warehouse-form',{ref:"warehouseForm",attrs:{"submit-label":"CREAR ALMACÉN","saving":_vm.saving},on:{"submit":_vm.createWarehouse}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }